<template>
    <div :class="[{'py-5 duration-300': focusText || content},{'pb-5 duration-300': !focusText}]">
        <div class="relative font-regular" :class="[isError ? 'pb-2.5':'']">
            <input type="tel"
                class="w-full p-2.5 placeholder-a-gray-78787D rounded-10 text-16 border-b"
                :class="[isError ? 'border-a-red-FF5045' : !content ? 'border-a-gray-D9DBDE':' border-a-blue-7db0ff']"
                v-model="content"
                :maxlength="inputMaxLength"
                :readonly="isDisable"
                :data-cy="$attrs['data-cy'] || inputLbl.name"
                @input="onChange()"
                @focus="onFocus(true)"
                @blur="onFocus(false)"
                @click="onClick()">
            <label class="block absolute left-2.5 duration-300 pointer-events-none"
                   :class="[{'top-3 text-16': !content && !focusText},
                        {'-top-5 text-16 bg-white': content || focusText},
                        {'-top-3 bg-inherit ': isDisable},
                        !content ? 'text-a-gray-78787D' : 'text-a-black-000926']"
            > {{inputLbl.name}}</label>
            <div v-if="inputLbl.placeholder && !isError" class="text-a-gray-78787D text-14 px-2.5 pt-2">
                {{ inputLbl.placeholder }}
            </div>
            <div class="text-a-gray-78787D text-14 relative top-3 left-0 w-full flex items-start gap-2.5" v-if="isError">
                <img src="@/assets/icon/ic-warning-triangle.svg" alt="">
                <div>{{ getErrorMsg }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputNumberBorder",
    props: {
        // v-model
        inputValue:     { type: [String, Number] },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        isDisable:      { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: null,
            focusText: false
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
        },
        onChange: function() {
            let result = this.content;
            result = RegxHelper.removeNotNumber(result);

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        onFocus: function(focus) {
            this.focusText = focus;
        },
        onClick: function(){
            this.$emit('onClick');
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
